import $ from 'jquery'


// Header scroll based classes

const el = $('.header-sticky');
const elBottom = $('.header-sticky .header-bottom');
const navSticky = $('.nav-sticky');
let elHeight = el.outerHeight();
let elBottomHeight = elBottom.outerHeight();
let navStickyTop = navSticky.offset()?.top || 0;
let scrollTop = $(window).scrollTop();
let lastScrollTop = 0;

// Set navSticky top position if it exists
if (navSticky.length) {
	navSticky.css('top', elBottomHeight);
	navSticky.css('z-index', '99');
	navSticky.css('transition', 'all .2s ease-in-out');
}

if (scrollTop > 0) {
	el.addClass('header-scrolled-pos');
} else {
	el.addClass('header-initial-pos');
}

$(window).on('scroll', function () {
	scrollTop = $(this).scrollTop();
	const isNavStickyStuck = scrollTop >= navStickyTop - elHeight;

	// Header position classes
	if (scrollTop > 0) {
		el.removeClass('header-initial-pos').addClass('header-scrolled-pos');
	} else {
		el.removeClass('header-scrolled-pos').addClass('header-initial-pos');
	}

	// Scroll direction classes + navSticky transform
	if (scrollTop > elHeight) {
		if (scrollTop > lastScrollTop) {
			$('body').removeClass('scroll-up').addClass('scroll-down');
			if (navSticky.length && isNavStickyStuck) {
				navSticky.css('transform', 'translateY(0)');
			}
		} else {
			$('body').removeClass('scroll-down').addClass('scroll-up');
			if (navSticky.length && isNavStickyStuck) {
				navSticky.css('transform', 'translateY(2rem)');
			}
		}
	} else {
		if (navSticky.length) {
			navSticky.css('transform', '');
		}
	}

	// Remove transform if navSticky is not stuck
	if (navSticky.length && !isNavStickyStuck) {
		navSticky.css('transform', '');
	}

	lastScrollTop = scrollTop;
});


// Recalculate on resize
$(window).on('resize', function () {
	elBottomHeight = elBottom.outerHeight();
	navStickyTop = navSticky.offset()?.top || 0;
	if (navSticky.length) {
		navSticky.css('top', elBottomHeight);
	}
});

// Header search

$('.js-toggle-search').on('click', function (e) {
	e.preventDefault();
	$('.header-search').toggleClass('is-visible');
	$('.header-search input').get(0).focus();
});

$(document).on("keydown", function (e) {
	if (e.key == "Escape") {
		$('.header-search').removeClass('is-visible');
	}
});

$(document).on('click', function (e) {
	if (!$('.js-toggle-search, .header-search').is(e.target) && $('.header-search').has(e.target).length === 0) {
		$('.header-search').removeClass('is-visible');
	}
});
